import * as React from "react";
import ListItem from "@warda/library-ui/core/ListItem";
import { NavLink } from "react-router-dom";
import hexToRgbA from "@warda/library-ui/utils/hexToRgbA";
import { getTheme } from "@warda/library-ui/theme";
import { useContextAggrType, useContextDispatchMain } from "../Main";
import { ACTION_MAIN } from "../reducer";
const WindowSections = ({ view, text, icon, selected, onClose, }) => {
    const aggr = useContextAggrType();
    const dispatchMain = useContextDispatchMain();
    const onClick = React.useCallback(() => {
        var _a;
        if (!aggr.items.includes(aggr.value)) {
            dispatchMain({ type: ACTION_MAIN.AGGREGATETYPE, value: (_a = aggr.items) === null || _a === void 0 ? void 0 : _a[0] });
        }
        onClose();
    }, [aggr.items, aggr.value, dispatchMain, onClose]);
    return (React.createElement(NavLink, { style: {
            display: "block",
            textDecoration: "none",
            color: "inherit",
        }, to: `/${view}/` },
        React.createElement(ListItem, { key: view, id: view, label: text, icon: icon, style: {
                background: selected
                    ? hexToRgbA(getTheme().colors.theme1, 0.15)
                    : undefined,
            }, selected: selected, onClick: onClick, clickPropagation: true })));
};
export default WindowSections;
